import { translate } from 'loankeeper-common/helpers'

export const translateDialog = (key) => translate(`frm_dialog_check-${key}`)
export const translateRating = (key) => translate(`frm_credit_score-${key}`)
export default (key) => translate(`LKMESSAGE-${key}`)
